module.exports = __webpack_public_path__ + "img/recipients.7e23f8d3.png";